/**
 * Spinner — the one loading glyph, so every button, page and inline "working…"
 * state spins the same way. Size and colour are props; default inherits the
 * current text colour so it works on any background.
 */
import styles from "./Spinner.module.scss";

interface Props {
  /** Diameter in px. */
  size?: number;
  /** Stroke colour; defaults to currentColor. */
  color?: string;
  /** Accessible label; omit for a decorative spinner inside a labelled control. */
  label?: string;
  className?: string;
}

export const Spinner: React.FC<Props> = ({ size = 16, color, label, className }) => (
  <span
    className={`${styles.spinner} ${className ?? ""}`}
    style={{ width: size, height: size, borderColor: color, borderTopColor: "transparent" }}
    role={label ? "status" : undefined}
    aria-label={label}
    aria-hidden={label ? undefined : true}
  />
);
